/* Just Print It 3D - storefront fixes for the Refresh theme */

/*
 * Variant picker: when a new choice (e.g. a different Make on the Centre Console Tray) leaves the
 * other options on a combination that doesn't exist, the theme shows crossed-out pills and an
 * "Unavailable" button. Move each of those other options to its first valid value instead.
 * Never changes the option the customer just picked, and only acts when no variant exists at all
 * (a sold-out variant still exists, so sold-out choices are left alone).
 */
(function () {
  var lastChanged = null;
  var autoPicks = 0;

  function legendOf(fieldset) {
    var legend = fieldset.querySelector('legend');
    return legend ? legend.textContent.trim() : null;
  }

  document.addEventListener('change', function (event) {
    if (!event.isTrusted || !event.target.closest) return;
    var fieldset = event.target.closest('variant-selects fieldset');
    if (!fieldset) return;
    lastChanged = legendOf(fieldset);
    autoPicks = 0;
  }, true);

  function repair(selects) {
    var selected = selects.querySelector('[data-selected-variant]');
    if (!selected || selected.textContent.trim() !== 'null' || autoPicks >= 4) return;
    var fieldsets = selects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      if (legendOf(fieldsets[i]) === lastChanged) continue;
      var checked = fieldsets[i].querySelector('input:checked');
      if (!checked || !checked.classList.contains('disabled')) continue;
      var firstValid = fieldsets[i].querySelector('input:not(.disabled)');
      if (firstValid) {
        autoPicks++;
        firstValid.click();
      }
      return;
    }
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var selects = node.matches('variant-selects') ? node : node.querySelector('variant-selects');
        if (selects) setTimeout(function () { repair(selects); }, 0);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
